<template>
  <div class="city-contain">
    <van-list
      class="score-list"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="score-item" v-for="(item,index) in currentPageData" :key="index">
          <!-- <section> -->
        <section @click="goDetail(item)">
          <div class="tit">
            <div class="name">{{item.typeName}}</div>
            <!-- 这里的扣分是后台除以100计算的。 -->
            <div class="down">
              <div
                style="width: 100%; text-align: right;"
                :class="item.surpass ? 'txtDec' : ''"
              >{{`-${item.deduction}分`}}</div>
              <div class="timememo" v-if="item.surpass == 1 ">已达扣分上限</div>
            </div>
          </div>
          <template
            v-if="item.coseType == 'A' || item.coseType == 'A1' || item.coseType == 'A2' || item.coseType == 'A3' || item.coseType == 'C' ||  item.coseType == 'C1' ||  item.coseType == 'C2' ||  item.coseType == 'C3' ||  item.coseType == 'C4' || item.coseType == 'D' "
          >
            <div class="txt txtmemo">扣分原因：{{item.deductionReason}}</div>
            <div class="txt">审核时间：{{item.auditTime}}</div>
          </template>
          <template
            v-if=" item.coseType == 'E' || item.coseType == 'E1' || item.coseType == 'E2' || item.coseType == 'E3' "
          >
            <div class="txt txtmemo">受处理原因：{{item.deductionReason}}</div>
            <div class="txt">审核时间：{{item.auditTime}}</div>
          </template>
          <template v-if=" item.coseType == 'F' ">
            <div class="txt txtmemo">舆情级别：{{item.opinionLevelCN}}</div>
            <div class="txt">审核时间：{{item.auditTime}}</div>
          </template>
          <template v-if="item.coseType == 'B1'">
            <div class="txt">投诉地区：{{item.complaintArea}}</div>
            <div class="txt">响应时长：{{item.answerDuration ? item.answerDuration : '未响应'}}</div>
            <div class="txt">投诉时间：{{item.complaintTime}}</div>
          </template>
          <template v-if="item.coseType == 'B2'">
            <div class="txt">投诉地区：{{item.complaintArea}}</div>
            <div class="txt">办结时长：{{item.answerDuration}}</div>
            <div class="txt">投诉时间：{{item.complaintTime}}</div>
          </template>
          <template
            v-if="item.coseType == 'B3' || item.coseType == 'G' || item.coseType == 'H' || item.coseType == 'I' || item.coseType == 'J'"
          >
            <div class="txt">审核时间：{{item.auditTime}}</div>
          </template>
        </section>
      </div>
    </van-list>
  </div>
</template>

<script>
import auth_detail from '@/utils/auth_detail_comm.js'
export default {
  name: "timeList",
  props: {
    listData: {
      type: Array,
    },
    // 每页显示数量
    pageSize: {
      type: Number,
      default: () => 10,
    },
  },
  data() {
    return {
      totalPage: 1, // 统共页数，默认为1
      currentPage: 0, //当前页数 ，默认为1
      currentPageData: [], //当前页显示内容
      loading: false, // 加载状态
      finished: false, // 是否是最后一页
    };
  },
  mounted() {
    // 计算一共有几页
    this.totalPage = Math.ceil(this.listData.length / this.pageSize);
    // 计算得 0时设置为 1
    this.totalPage = this.totalPage == 0 ? 1 : this.totalPage;
  },
  methods: {
    // 加载事件
    onLoad() {
      //是否处于加载状态，加载过程中不触发load事件
      this.loading = true;
      setTimeout(() => {
        if (this.currentPage == this.totalPage) {
          this.finished = true;
          return;
        }
        this.currentPage++;
        this.setCurrentPageData();
      }, 1000);
    },
    // 设置当前页面数据，对数组操作的截取规则为[0~10],[10~20]...,
    setCurrentPageData() {
      let begin = (this.currentPage - 1) * this.pageSize;
      let end = this.currentPage * this.pageSize;
      this.currentPageData = [
        ...this.currentPageData,
        ...this.listData.slice(begin, end),
      ];
      this.loading = false;
    },
    goDetail(item) {
      console.log("-----跳详情页参数：", item);
      if (item.coseType === "F") { // 负面舆情
        this.$router.push({
          path: "/appraise/deductDetailNegative",
          query: {
            year: item.year,
            quarter: item.quarter,
            area: item.area,
            id: item.id,
            updateAuth: auth_detail.getNegativeAuth('updateAuth'),
            deleteAuth: auth_detail.getNegativeAuth('deleteAuth'),
            userAuthoirese: auth_detail.getNegativeAuth('userAuthoirese'),
            isExceed: item.surpass,
          },
        });
      }else if(item.coseType === "B1"){ //投诉5分钟内未响应情况
        this.$router.push({ path: '/appraise/fiveMunites', query:{
            orderNo: item.orderNo,//缺字段
            orderSubNo: item.orderSubNo, //缺字段
            year: item.year, 
            areaName: item.areaName,
            quarter: item.quarter,
            isExceed: item.surpass
          }});
      }else if(item.coseType === "B2"){ //投诉24 小时未办结
         this.$router.push({ path: '/appraise/twentyFourHours', query:{
            orderNo: item.orderNo,//缺字段
            orderSubNo: item.orderSubNo, //缺字段
            year: item.year, 
            areaName: item.areaName,
            quarter: item.quarter,
            dealType: 'B2',
            isExceed: item.surpass
          }});
      }else if(item.coseType === "B3"){ //投诉24小时未达95%
          this.$router.push({ path: '/appraise/nintyFivePercent', query:{
            id: item.id,
            year: item.year, 
            areaName: item.areaName,
            quarter: item.quarter,
            isExceed: item.surpass
          }});
      }else if(item.coseType === "E" || item.coseType === 'E1' || item.coseType === 'E2' || item.coseType === 'E3'){//受到上报批评模块
          this.$router.push({
            path: "/appraise/deductDetailNotifi",
            query: {
            id: item.id,
            area: item.area,
            year: item.year,
            quarter: item.quarter,
            userAuthoirese: auth_detail.getnotificationAuth('userAuthoirese'),
            updateAuth: auth_detail.getnotificationAuth('updateAuth'),
            deleteAuth: auth_detail.getnotificationAuth('deleteAuth'),
            accidentListAuth: auth_detail.getnotificationAuth('accidentListAuth'),
            meetListAuth: auth_detail.getnotificationAuth('meetListAuth'),
            abarbeitungListAuth: auth_detail.getnotificationAuth('abarbeitungListAuth'),
            },
      });
      }else if(item.coseType === 'A1' ||  item.coseType === 'A2' || item.coseType === 'A3'){ //综合监管模块
          this.$router.push({
            path: "/appraise/deduction_detail",
            query: {
            monitorType: item.coseType,
            subName: item.typeName,
            year: item.year,
            quarter: item.quarter,
            area: item.area,
            },
        });
      }else if(item.coseType === 'C' || item.coseType === 'C1' || item.coseType === 'C2' || item.coseType === 'C3' || item.coseType === 'C4'){ //涉旅企业诚信评价进展情况
          this.$router.push({
            path: "/appraise/creditDetail",
            query: {
            area: item.area,
            integrityType: item.coseType,
            quarter: item.quarter,
            year: item.year,
            updateAuth: auth_detail.getcreditnAuth('updateAuth'),
            deleteAuth: auth_detail.getcreditnAuth('deleteAuth'),
            userAuthoirese: auth_detail.getcreditnAuth('userAuthoirese'),
            },
        });
      }else if(item.coseType === 'D'){ //涉旅安全事故发生情况
        this.$router.push({
        path: "/appraise/deductDetail",
        query: {
          id: item.id,
          area: item.area,
          quarter: item.quarter,
          year: item.year,
          isExceed: item.surpass,
          updateAuth: auth_detail.getTranAcidentAuth('updateAuth'),
          deleteAuth: auth_detail.getTranAcidentAuth('deleteAuth'),
          userAuthoirese: auth_detail.getTranAcidentAuth('userAuthoirese'),
        },
		});
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.score-list {
  margin-top: 8px;
  .score-item {
    padding: 16px;
    border-bottom: solid 1px #eeeeee;
    .tit {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 14px;
      .name {
        color: rgba(51, 51, 51, 1);
      }
      .down {
        color: #ff4d4d;
        display: flex;
        flex-wrap: wrap;
        justify-content: right;
        position: relative;
      }
      .txtDec {
        text-decoration: line-through;
      }
      .timememo {
        color: #ff8c19;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        // text-align: right;
        width: 100px;
        margin-top: 6px;
        position: absolute;
        right: -30px;
        top: 14px;
      }
    }
    .txt {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 16px;
      margin-top: 12px;
    }
    .txtmemo {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 76%;
    }
  }
  .score-item:last-child {
    border-bottom: none;
  }
}
</style>
